import { render, staticRenderFns } from "./plaaybackVideo.vue?vue&type=template&id=b2be0682&scoped=true&"
import script from "./plaaybackVideo.vue?vue&type=script&lang=js&"
export * from "./plaaybackVideo.vue?vue&type=script&lang=js&"
import style0 from "./plaaybackVideo.vue?vue&type=style&index=0&id=b2be0682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2be0682",
  null
  
)

export default component.exports